import { format } from 'date-fns';

/**
 * Formata uma data no padrão brasileiro com horário: `dd/MM/aaaa HH:mm`.
 * Usado em toda a UI v2 onde uma data é exibida. Retorna '' para valores
 * ausentes/ inválidos (o caller decide o fallback, ex.: '—').
 */
export function formatDateTimeBR(value?: string | number | Date | null): string {
  if (value === null || value === undefined || value === '') return '';
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? '' : format(d, 'dd/MM/yyyy HH:mm');
}

/** Apenas a data no padrão brasileiro: `dd/MM/aaaa` (sem horário). */
export function formatDateBR(value?: string | number | Date | null): string {
  if (value === null || value === undefined || value === '') return '';
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? '' : format(d, 'dd/MM/yyyy');
}

/**
 * O fuso IANA do navegador (`America/Sao_Paulo`), ou `undefined` quando o
 * navegador não informa. É o fuso em que o agente do Chat mostra datas e horas.
 */
export function browserTimeZone(): string | undefined {
  try {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return zone || undefined;
  } catch {
    return undefined;
  }
}
